const LogoutIcon = ({ size = 22 }) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 24 24">
    <path d="M16 17l5-5-5-5M21 12H9M13 21a9 9 0 1 1 0-18" stroke="#d32f2f" strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);
export default LogoutIcon;